// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1__b665eb31bc636686df4d","cls2":"ImpactHubProfileCard-cls2__a688c2e6a0cb3e2a875c ImpactHubProfileCard-cls1__b665eb31bc636686df4d"};